import ModalCoachActions from './ModalCoachActions';

export default ModalCoachActions;
